<template>
  <editable-box :mode="mode" :includeBtns="['edit']" @onEdit="hanldeEdit">
    <resize-box
      :width="imageSize.width"
      :height="imageSize.height"
      :active="mode == 'edit' ? ['r', 'rb', 'b'] : []"
      @resize:end="handleResizeEnd"
    >
      <div class="image-album">
        <swiper class="swiper-top" ref="swiperTop" :auto-destroy="true" :auto-update="true" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in imgs" :key="index" :zoom="true" class="swiper-slide">
            <img :src="item" alt="" class="swiper-lazy preview-image" />
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" v-if="imgs.length > 1"></div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-next" v-if="imgs.length > 1"></div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        <!-- 缩略图 -->
        <!-- <div class="thumbs">
          <swiper
            class="swiper-thumbs"
            ref="swiperThumbs"
            :options="swiperOptionThumbs"
          >
            <swiper-slide
              v-for="(item, index) in imgs"
              :key="index"
              class="swiper-slide"
            >
              <img :src="item" alt="" class="swiper-lazy" />
            </swiper-slide>
          </swiper>
          <div class="swiper-thumbs-prev "></div>
          <div class="swiper-thumbs-next"></div>
        </div> -->
        <!-- panel -->
        <!-- 多图编辑 -->
        <image-edit-panel
          v-if="mode === 'edit'"
          ref="imageEditPanel"
          :mode="mode"
          :imgs="imgs"
          @onChange="handleImgsChange"
        ></image-edit-panel>
      </div>
    </resize-box>
  </editable-box>
</template>

<script>
import draggable from "vuedraggable";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import EditableBox from "../../../../components/EditableBox/index.jsx";
import ResizeBox from "../../../../components/ResizeBox";
import ImageEditPanel from "./ImageEditPanel";

export default {
  name: "ImageAlbum",
  components: {
    draggable,
    Swiper,
    SwiperSlide,
    EditableBox,
    ResizeBox,
    ImageEditPanel
  },
  props: {
    mode: String,
    imgs: {
      type: Array,
      default: () => []
    },
    imageSize: {
      type: Object,
      default: () => ({
        width: "160px",
        height: "160px"
      })
    }
  },
  data() {
    return {
      drag: false,
      dragableImgs: this.imgs,
      swiperOptions: {
        initialSlide: 0,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // pagination: {
        //   el: ".img-view-pagination",
        //   type: "fraction"
        // }
      },
      swiperOptionThumbs: {
        initialSlide: 0,
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-thumbs-next",
          prevEl: ".swiper-thumbs-prev"
        }
      },
      showPanel: false,
      // 1本地上传,右下角水印，2全身加水印上传
      uploadType: 1,
      // update - 编辑 add - 添加
      editImageType: "",
      editImageIndex: -1
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  watch: {
    imgs(val) {
      this.dragableImgs = val;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // const swiperTop = this.$refs.swiperTop.$swiper;
      // const swiperThumbs = this.$refs.swiperThumbs.$swiper;
      // swiperTop.controller.control = swiperThumbs;
      // swiperThumbs.controller.control = swiperTop;
    });
  },

  methods: {
    handleSortImgs() {
      this.$emit("onChange", this.dragableImgs);
    },
    handleResizeEnd({ width, height }) {
      this.$refs.swiperTop.updateSwiper();
      this.$emit("onResize", width, height);
    },
    hanldeEdit() {
      this.$refs.imageEditPanel.open();
    },
    handleImgsChange(imgs) {
      this.$emit("onChange", imgs);
    }
  }
};
</script>

<style lang="less" scoped>
.image-album {
  width: 100%;
  height: 100%;
  --swiper-navigation-color: rgba(211, 211, 211, 0.8);
  --swiper-navigation-size: 24px;
  .swiper-top {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: 1px solid #ababab;

    .swiper-slide {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      border: 1px solid #fff;
      overflow: hidden;
      display: flex;
      align-items: center;
    }
    img {
      width: 100%;
      border-radius: 8px;
    }
  }
  .thumbs {
    position: relative;
    margin-top: 12px;
    width: 160px;
    height: 48px;
    overflow: hidden;

    .swiper-thumbs-prev {
      position: absolute;
      left: 0;
      top: 0;
      width: 20px;
      height: 48px;
      background: #323239;
      text-align: center;
      line-height: 48px;
      z-index: 100;
      &::before {
        content: "";
        display: inline-block;
        border-right: 6px solid #fff;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-radius: 2px;
      }
    }
    .swiper-thumbs-next {
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 48px;
      background: #323239;
      text-align: center;
      line-height: 48px;
      z-index: 100;
      &::before {
        content: "";
        display: inline-block;
        border-left: 6px solid #fff;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-radius: 2px;
      }
    }
  }
  .swiper-thumbs {
    width: 200px;
    height: 100%;
    margin: 0 auto;
    padding: 5px 30px;
    transform: translateX(-60px);
    background-color: #f3f3f3;
    .swiper-slide {
      width: 37px !important;
      height: 37px;
      border-radius: 4px;
      border: 1px solid #ababab;
      overflow: hidden;
    }
    /deep/ .swiper-slide-active {
      border: 2px solid #232323;
    }
    img {
      width: 100%;
      border-radius: 4px;
      object-fit: cover;
    }
  }
}
.image-list {
  padding: 15px;
}
.image-box {
  position: relative;
  display: inline-flex;
  width: 106px;
  height: 106px;
  border-radius: 8px;
  border: 1px solid #ababab;
  margin-right: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  &:hover {
    .edit-btns {
      display: inline-flex;
    }
  }
  img {
    width: 100%;
  }
  .edit-btns {
    display: none;
    position: absolute;
    height: 20px;
    right: 3px;
    top: 3px;
    .btn {
      width: 20px;
      height: 20px;
      color: #ffffff;
      border-radius: 4px;
      margin-left: 3px;
      border: none;
      vertical-align: middle;
      line-height: 20px;
      text-align: center;
      &:hover {
        opacity: 0.9;
      }
      .icon {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.upload-image {
  width: 106px;
  height: 106px;
  border-radius: 8px;
  background: #727c86;
  border: 2px solid #ffffff;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  vertical-align: top;
  .upload-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    text-align: center;
    line-height: 32px;
    font-size: 18px;
    margin-bottom: 12px;
    color: #fff;
  }
  .upload-desc {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
</style>
